module.exports = __webpack_public_path__ + "img/emtpy.14ad5709.png";